export default {
  init() {
    let faktabladButton = $('.faktablad-generator');
    let contentContainer = $('.single-content');

    faktabladButton.click(function (e) {
      console.log('Faktablad generator...');
      e.preventDefault(); //save generation type
      const type = $(this).data('type');
      $('#faktablad-generator-form [name="type"]').val(type);
      $('#faktablad-generator-form').submit();
    });
    if ($(window).width() < 767) {
      let contentHeight = contentContainer.outerHeight();
      if (contentHeight > 500) {
        contentContainer.addClass('single-content--isExpandable');
        contentContainer.find('.expand-toggle').click(function () {
          console.log('expand content');
          contentContainer.addClass('single-content--isExpanded');
        });
      }
    }

    let backButton = $('.backbutton-logic');
    backButton.click(function (e) {
      e.preventDefault();

      /*
      - history.back goes to same page if user loads the page twice
      - history.back goes out of the site if the user comes from an outside link
      - the history browser Api does not contain anything regarding the previous url (for clear security issues)
      - we can't track the user around the site because if he goes out and then back in, we'd lose track
      */

      history.back();
    });

    //Show more related posts
    let showMorePosts = $('.show-more-related-posts');
    if ($('.related-verksamheter-posts-wrapper article:hidden').length === 0) {
      showMorePosts.hide();
    }
    showMorePosts.on('click', function () {
      let posts = $('.related-verksamheter-posts-wrapper article:hidden').slice(
        0,
        3,
      );
      posts.slideDown();
      if (
        $('.related-verksamheter-posts-wrapper article:hidden').length === 0
      ) {
        showMorePosts.hide();
      }
    });
  },
};
